export default __webpack_public_path__ + "media/integrations/ie-d42e9565.svg";